import { useAuthStore } from '@/stores/authStore'
import { AdminDashboard } from './AdminDashboard'
import { ManagerDashboard } from './ManagerDashboard'
import { OperativeDashboard } from './OperativeDashboard'

// Route to role-appropriate dashboard component
export function DashboardPage() {
  const user = useAuthStore((state) => state.user)
  const roleLevel = user?.role?.level ?? 5

  // L1-L2: Admin dashboard (global overview + financials)
  if (roleLevel <= 2) {
    return <AdminDashboard />
  }

  // L3: Manager dashboard (team + approvals + clients)
  if (roleLevel === 3) {
    return <ManagerDashboard />
  }

  // L4-L5: Operative dashboard (my tasks kanban + deadlines)
  return <OperativeDashboard />
}
